module.exports = __webpack_public_path__ + "media/components/src/assets/images/store-image/smart-717086609b3dfed9c247cd74011518d9.png";